import { render, staticRenderFns } from "./Import.vue?vue&type=template&id=16644582"
import script from "./Import.vue?vue&type=script&lang=js"
export * from "./Import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16644582')) {
      api.createRecord('16644582', component.options)
    } else {
      api.reload('16644582', component.options)
    }
    module.hot.accept("./Import.vue?vue&type=template&id=16644582", function () {
      api.rerender('16644582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Import.vue"
export default component.exports